/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 7/21/2023
 */
import React, { useState, useEffect } from "react"
import api from "../../../../base/services/ResApi"
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling"
import Alerts from "../../../../base/errorHandeling/Alerts"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import { Box, IconButton, Tooltip } from "@mui/material"
import { Check, HighlightOff } from "@mui/icons-material"
import ConfirmModal from "../../../components/confirmRejectModals/ConfirmModal"
import RejectModal from "../../../components/confirmRejectModals/RejectModal"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"
import TerminalsColumns from "./TerminalsColumns"

const PendingTerminals = ({
  updateData,
  setUpdateData,
  setPendingCount,
  isSearch,
  setIsSearch,
  filterType,
  filterByVal,
}) => {
  const [pendingData, setPendingData] = useState([])
  const [isLoading, setisLoading] = useState(false)
  const [rowsData, setRowsData] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)

  //modal States
  const [confirmModelOpen, setConfirmModelOpen] = useState(false)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [iswarning, setIswarning] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [appRowCount, setAppRowCount] = useState(0)
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10,
  })
  const [tableState, setTableState] = useState()

  // table data loading
  let alertProps = {}
  if (iserror) {
    alertProps = {
      color: "error",
      children: "Error loading data",
    }
  }

  const columns = TerminalsColumns()

  let pendConfig = {
    headers: {
      Action: "V_ALL_NON_APPR_TMNL",
      "Page-Number": 1,
      "Page-Size": 5000,
      "Sort-Column": "tmnl_id",
      "Sort-Order": "asc",
      Filter: filterType,
      Value: filterByVal,
      "Is-Pagination": "true",
    },
  }

  useEffect(() => {
    if (isSearch || updateData) {
      setisLoading(true)

      api
        .get("/terminals", pendConfig)
        .then((res) => {
          setPendingData(res.data?.dataList)
          setAppRowCount(res.data?.total)
          setPendingCount(res.data?.total)

          setisLoading(false)
          setErrorMessages([])
          setIserror(false)
          setIsUnauhtError(false)
          setIsSearch(false)
          setUpdateData(false)
        })
        .catch((error) => {
          setIsSearch(false)
          setUpdateData(false)
          setisLoading(false)

          FetchErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow,
            setIsUnauhtError
          )
        })
    }
  }, [
    isUnauhtError,
    isSearch,
    pagination.pageIndex,
    pagination.pageSize,
    updateData,
  ])

  useEffect(() => {
    if (iserror === true) {
      setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
      }, 10000)
    }
  }, [iserror])

  useEffect(() => {
    if (isSuccess === true || iswarning === true) {
      setTimeout(() => {
        setIsSuccess(false)
        setIswarning(false)
        setSuccessMessages([])
      }, 3000)
    }
  }, [isSuccess])

  const handleClearData = () => {
    setIsSubmit(false)
    setConfirmModelOpen(false)
    setRejectModalOpen(false)
    setTimeout(() => {
      setIsSuccess(false)
      setIswarning(false)
      setSuccessMessages([""])
    }, 3000)
    setTimeout(() => {
      setIserror(false)
      setIserrorShow(false)
      setIsUnauhtError(false)
      setErrorMessages([])
    }, 10000)
  }

  let patchPendConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  }

  const handleAccept = () => {
    setIsSubmit(true)
    const approvedIdList = rowsData?.map((row) => ({
      approvedId: row.approveId,
    }))

    const pendUser = {
      approvedIdList,
      rejectedIdList: [],
    }
    const appRow = JSON.stringify(pendUser)

    api
      .patch("/terminals", appRow, patchPendConfig)
      .then((res) => {
        tableState.resetRowSelection()
        setUpdateData(true)

        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        res.data?.code === 202 ? setIswarning(true) : setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClearData()
      })
      .catch((error) => {
        setIsSuccess(false)
        setIswarning(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        handleClearData()
      })
  }

  const handleReject = () => {
    setIsSubmit(true)
    const rejectedIdList = rowsData?.map((row) => ({
      rejectedId: row.approveId,
    }))

    const pendUser = {
      approvedIdList: [],
      rejectedIdList,
    }
    const appRow = JSON.stringify(pendUser)

    api
      .patch("/terminals", appRow, patchPendConfig)
      .then((res) => {
        tableState.resetRowSelection()
        setUpdateData(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClearData()
      })
      .catch((error) => {
        setIsSuccess(false)
        setIswarning(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        handleClearData()
      })
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          iswarning={iswarning}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <br />
      <MaterialReactTable
        enableColumnVirtualization
        columns={columns}
        data={pendingData ?? []}
        state={{
          columnFilters,
          globalFilter,
          isLoading,
        }}
        getRowId={(row) => row.phoneNumber}
        initialState={{ showColumnFilters: false }}
        manualPagination
        muiToolbarAlertBannerProps={alertProps}
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        rowCount={appRowCount}
        muiTablePaginationProps={{
          rowsPerPageOptions: [10],
        }}
        editingMode="modal"
        enableColumnOrdering
        enableGrouping
        enablePinning
        enableRowSelection
        enableSelectAll
        renderTopToolbarCustomActions={({ table }) => {
          return (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Tooltip arrow placement="left" title="Accept">
                  <IconButton
                    color="success"
                    disabled={!table.getSelectedRowModel().flatRows.length}
                    onClick={() => {
                      setRowsData([])
                      table.getSelectedRowModel().flatRows.forEach((row) => {
                        setRowsData((prevData) => [
                          ...prevData,
                          { ...row.original },
                        ])
                      })
                      setConfirmModelOpen(true)
                      setTableState(table)
                    }}
                    variant="contained"
                  >
                    <Check />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Reject">
                  <IconButton
                    color="error"
                    disabled={!table.getSelectedRowModel().flatRows.length}
                    onClick={() => {
                      setRowsData([])
                      table.getSelectedRowModel().flatRows.forEach((row) => {
                        setRowsData((prevData) => [
                          ...prevData,
                          { ...row.original },
                        ])
                      })
                      setRejectModalOpen(true)
                      setTableState(table)
                    }}
                    variant="contained"
                  >
                    <HighlightOff />
                  </IconButton>
                </Tooltip>
              </Box>
            </div>
          )
        }}
      />

      <ConfirmModal
        open={confirmModelOpen}
        isSubmit={isSubmit}
        handleAccept={handleAccept}
        onClose={() => {
          setConfirmModelOpen(false)
        }}
      />
      <RejectModal
        open={rejectModalOpen}
        isSubmit={isSubmit}
        handleReject={handleReject}
        onClose={() => {
          setRejectModalOpen(false)
        }}
      />
    </div>
  )
}
export default PendingTerminals
